import { render } from "./ImageMarkupControl.vue?vue&type=template&id=81ca505e&scoped=true"
import script from "./ImageMarkupControl.vue?vue&type=script&lang=js"
export * from "./ImageMarkupControl.vue?vue&type=script&lang=js"

import "./ImageMarkupControl.vue?vue&type=style&index=0&id=81ca505e&scoped=true&lang=scss"
import "./ImageMarkupControl.vue?vue&type=style&index=1&id=81ca505e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ca505e"]])

export default __exports__